import React from "react";
import styled from "styled-components";
import { Flex, Box } from "grid-styled";
import { Link } from "react-router-dom";
import StatusLabel from "./StatusLabel";
import joinPath from "../utils/join-path";
import { STATUS_COLOR, DIVIDER } from "../settings/colors";

const statusColor = service => STATUS_COLOR[service.status];

// eslint-disable-next-line
const ServiceCardBody = styled.div`
  border-style: solid;
  border-color: ${DIVIDER};
  border-width: 0 1px 1px 1px;
  border-radius: 0 0 3px 3px;
`;

const ServiceCardHeader = styled.div`
  color: #fff;
  font-size: 14px;
  background: ${({ bgColor }) => bgColor};
  border-radius: 3px; /* TODO: only round two sides */
  padding: 8px 12px;

  & a {
    color: white;
    text-decoration: none;
    font-weight: 600;
  }
`;

const ServiceCard = ({ service, baseUrl }) => {
  return (
    <Box my={2}>
      <ServiceCardHeader bgColor={statusColor(service)}>
        <Flex justify="space-between" align="center">
          <Link to={joinPath(baseUrl, `/services/${service.id}`)}>
            {service.serviceType}
          </Link>
          <StatusLabel inverse status={service.status} />
        </Flex>
      </ServiceCardHeader>
      {/* <ServiceCardBody /> */}
    </Box>
  );
};

export default ServiceCard;



// WEBPACK FOOTER //
// ./src/components/ServiceCard.js